module.exports = __webpack_public_path__ + "media/images/product/p_d-e023c341a401cb593cee7c66fb4b1702.png";